
/*


✅ Premium SaaS/Apple-style UI
✅ Export Excel button
✅ Subscriber count
✅ Search subscribers
✅ Loading improvement
✅ Empty state message
✅ Better responsive table
✅ Refresh button
✅ Date formatting
✅ Better error handling


*/



import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import axios from "axios";

import {
  Container,
  Table,
  Card,
  Spinner,
  Button,
  Form,
  Row,
  Col,
} from "react-bootstrap";


function AdminNewsletter() {


const [subscribers,setSubscribers] = useState([]);

const [loading,setLoading] = useState(true);

const [error,setError] = useState("");

const [search,setSearch] = useState("");



/* ================= LOAD SUBSCRIBERS ================= */


const loadSubscribers = async()=>{

try{

setLoading(true);

const res = await axios.get(
"https://apimyshop.myidealtd.co.uk/api/newsletter"
);


setSubscribers(res.data);


}
catch(error){

console.error(error);

setError(
"Failed to load subscribers"
);

}
finally{

setLoading(false);

}

};



useEffect(()=>{

loadSubscribers();

},[]);



/* ================= EXPORT EXCEL ================= */


const exportExcel =()=>{


const data = subscribers.map(
(sub,index)=>(

{

No:index+1,

Email:sub.email,

Status:sub.status,

Subscribed:
new Date(
sub.createdAt
).toLocaleDateString()

}

));


const worksheet =
XLSX.utils.json_to_sheet(data);


const workbook =
XLSX.utils.book_new();


XLSX.utils.book_append_sheet(
workbook,
worksheet,
"Subscribers"
);


const excelBuffer =
XLSX.write(
workbook,
{
bookType:"xlsx",
type:"array"
}
);



const file = new Blob(
[excelBuffer],
{
type:
"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
}
);


saveAs(
file,
"newsletter-subscribers.xlsx"
);


};



/* ================= SEARCH ================= */


const filteredSubscribers =
subscribers.filter((sub)=>

sub.email
.toLowerCase()
.includes(
search.toLowerCase()
)

);





if(loading){

return(

<div
style={{
height:"100vh",
display:"flex",
alignItems:"center",
justifyContent:"center"
}}
>

<Spinner animation="border"/>

</div>

)

}





return(


<Container
fluid
className="py-5"
style={{
background:"#f8fafc",
minHeight:"100vh"
}}
>



<Card

style={{

border:"none",

borderRadius:"30px",

boxShadow:
"0 20px 60px rgba(0,0,0,.08)"

}}

>


<Card.Body
style={{
padding:"40px"
}}
>



{/* HEADER */}


<Row
className="align-items-center mb-4"
>


<Col md={6}>


<h2

style={{

fontWeight:800,

color:"#111827"

}}

>

📩 Newsletter Subscribers

</h2>


<p
style={{
color:"#6b7280"
}}
>

Manage customer email subscriptions

</p>


</Col>



<Col
md={6}
className="text-md-end"
>


<Button

onClick={exportExcel}

style={{

border:"none",

borderRadius:"999px",

padding:"12px 25px",

fontWeight:700,

background:
"linear-gradient(135deg,#2563eb,#3b82f6)"

}}

>

⬇ Export Excel

</Button>


<Button

onClick={loadSubscribers}

variant="dark"

style={{

marginLeft:"10px",

borderRadius:"999px",

padding:"12px 25px",

fontWeight:700

}}

>

🔄 Refresh

</Button>



</Col>


</Row>





{/* STATISTICS */}


<Row className="mb-4">


<Col md={4}>


<Card
style={{

border:"none",

borderRadius:"20px",

background:"#eff6ff"

}}
>


<Card.Body>


<h3
style={{
fontWeight:800,
color:"#2563eb"
}}
>

{subscribers.length}

</h3>


<p>

Total Subscribers

</p>


</Card.Body>


</Card>


</Col>


</Row>






{/* SEARCH */}


<Form.Control

placeholder="Search email..."

value={search}

onChange={(e)=>
setSearch(e.target.value)
}

style={{

borderRadius:"15px",

padding:"14px",

marginBottom:"25px"

}}

/>






{error &&

<p
style={{
color:"red"
}}
>

{error}

</p>

}






{filteredSubscribers.length===0 ?


<div
style={{
textAlign:"center",
padding:"50px",
color:"#6b7280"
}}
>

<h4>
No subscribers found
</h4>

</div>



:

<Table
responsive
hover
>


<thead>

<tr>

<th>#</th>

<th>Email</th>

<th>Status</th>

<th>Date</th>

</tr>

</thead>


<tbody>


{
filteredSubscribers.map(
(sub,index)=>(


<tr
key={sub._id}
>


<td>

{index+1}

</td>



<td>

{sub.email}

</td>




<td>

<span

style={{

background:"#dcfce7",

color:"#15803d",

padding:"6px 14px",

borderRadius:"999px",

fontWeight:600

}}

>

{sub.status}

</span>


</td>




<td>

{
new Date(
sub.createdAt
)
.toLocaleDateString()
}


</td>


</tr>


))

}



</tbody>



</Table>


}



</Card.Body>


</Card>


</Container>


)


}


export default AdminNewsletter;